<template>
    <div>
        <div class="flex items-center">
            <h2 class="section-title">{{$t('pages.dashboard.components.tta.title')}}</h2>
        </div>
        <div class="w-full block lg:flex flex-row mt-3 space-x-0 lg:space-x-4" v-if="auction">
            <div class="">
                <floor-sales-today :value="floorSalesToday"/>
            </div>

            <div class="w-full mt-8 lg:mt-0">
                <div class="bg-white tile h-full">
                    <div class="px-4 py-3">
                        <auction-current-level :name="auction.name"
                                               :current-level-price="currentLevel.price"
                                               :current-level-sold-quantity="currentLevel.quantity_used"
                                               :next-level-price="nextLevel.price"
                                               :next-level-quantity="nextLevel.quantity"
                                               :current-level-planned-quantity="currentLevel.quantity"
                        ></auction-current-level>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex items-end pt-4">
            <button @click="goToControlPanel()" type="button" class="btn btn-primary ml-auto" v-if="this.auction">
                {{$t('pages.dashboard.components.tta.goto_control_panel_button_label')}}
            </button>
        </div>
        <div class="bg-white tile my-5" v-if="!this.auction">
            <div class="px-4 py-5 sm:p-6">
                <div class="flex sm:items-start sm:justify-between">
                    <div class="flex">
                        <h3 class="text-xl leading-6 font-medium mr-5"><icon name="emoji-sad" class="h-10"/></h3>
                        <div class="mt-2 max-w-xl text-sm text-gray-500">
                            <p>{{$t('pages.controlpanel.index.no_running_auction')}}</p>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                        <button @click="goToPlanning()" type="button" class="btn btn-primary">
                            {{$t('pages.dashboard.components.tta.goto_planning_button_label')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import FloorSalesToday from "./FloorSalesToday";
import AuctionCurrentLevel from "./AuctionCurrentLevel";
import Icon from "@/Shared/Icon";
import moment from "moment";

export default {
    layout: Layout,
    components: {
        AuctionCurrentLevel,
        FloorSalesToday,
        Icon
    },
    props: {
        auction: Object,
        currentLevel: Object,
        nextLevel: Object
    },
    methods: {
        goToControlPanel() {
            this.$inertia.visit(
                route('controlpanel')
            );
        },
        goToPlanning() {
            this.$inertia.visit(route('auctions.planning'));
        },
    },
    computed: {
        floorSalesToday() {
            return this.auction.bids.reduce((accumulator, bid) => {
                return accumulator + (bid.quantity * bid.amount);
            }, 0);
        },
        soldQuantity() {
            let soldQuantity = 0;
            let that = this;
            if(this.auction.bids) {
                this.auction.bids.forEach((bid) => {
                    const bidDate = moment(bid.created_at, moment.ISO_8601);
                    const levelStartDate = moment(that.currentLevel.date_started, moment.ISO_8601);
                    if(bidDate > levelStartDate) {
                        soldQuantity += bid.quantity;
                    }
                });
            }
            return soldQuantity;
        }
    }
}
</script>
